export const SET_ANALYTICS_DATA = 'analytics/SET_ANALYTICS_DATA';
export const SET_ANALYTICS_TIME_RANGE = 'analytics/SET_ANALYTICS_TIME_RANGE';
export const SET_ANALYTICS_FILTERS = 'analytics/SET_ANALYTICS_FILTERS';
export const SET_ANALYTICS_LOADING = 'analytics/SET_ANALYTICS_LOADING'; 